import { render } from "./deleted.vue?vue&type=template&id=7b958754&scoped=true"
import script from "./deleted.vue?vue&type=script&lang=js"
export * from "./deleted.vue?vue&type=script&lang=js"

import "./deleted.vue?vue&type=style&index=0&id=7b958754&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b958754"]])

export default __exports__